import React, { useState } from "react";
import { withAuthentication } from "@/hoc/withAuthentication";
import { warningAlert } from "@/utility/helpers";
import Modal from "@/components/Modal";
import { getActiveShop } from "@/constants/utility";
import SwitchButton from "@/custom_components/SwitchButton/SwitchButton";
import AdminCodeForm from "./AdminCodeForm";
import ModalFloat from "@/custom_components/ModalFloat";

const tooltip = `With store mode active you can limit what features are available. When store mode is active some administrative features are hidden or disabled, you will also be required to put the employee code when creating sales, repairs, inventory count etc…`;

const AdminToken = ({ user, httpClient, close, }) => {
  const shops = user.storesData.map(({ _id }) => _id).join(",");
  const shop = getActiveShop(user);
  const handleSubmit = async(employeeCode) => {
    if (/true/i.test(shop.storemode)===active) {
      warningAlert({ message: "No changes were made" });
      return
    }
    try {
      await  httpClient
    .post("/account/admin-code/" + shops, { employeeCode })
    await httpClient.put("/repairshop/updatestoremode/" + shop._id, {
      storemode: active,
    });
    user.updateShop({ ...shop, storemode: !active });
       close();
    // window.location.reload();
    } catch (err) {
      warningAlert({ message: "Invalid Admin code provided." });
    }
  };
  const handleReset = async() => {
    try {
    await httpClient.post("/account/forgotpin", {
      email: user.email,
      repairshopID: shop._id
    })
    .then((res) => {
      warningAlert({
        message:
          res.message,
        status: "success",
      });
    })
    // window.location.reload();
    } catch (err) {
      if (err.response && err.response.data && err.response.data.message) {
        warningAlert({ api: err.response.data.message }); 
      } else {
        warningAlert({ api: 'An unexpected error occurred.' }); 
      }
    }
  };
  const [active, setActive] = useState(() => /true/i.test(shop.storemode));
  const handleChange = async (token) => {
    setActive(!active);
  };

  return (
    <ModalFloat >
      <div className="uk-border-rounded">
        <div className="uk-padding-small">
          <a
            className="uk-modal-close uk-float-right uk-link-text uk-light"
            onClick={close}>
            <i uk-icon='icon: close;ratio:1.5' />
          </a>
          <span className="uk-text-bold uk-text-large">Store Mode</span>
        </div>
        <section className="uk-padding-small">
          <div className="uk-padding-small">
            <div className="uk-grid-small uk-child-width-expand border-radius-15" uk-grid="">
              <div className="uk-text-left ">
                <span className=" pointer" uk-icon="icon: info; ">
                  {" "}
                </span>
                <div uk-drop="mode: click ">
                  <div className="uk-width-1-1 uk-flex uk-flex-center uk-flex-middle uk-card uk-padding-small uk-card-default">
                    <p>{`With store mode active you can limit what features are available...`}</p>
                    <a
                      className="uk-link-text uk-light uk-drop-close"
                     >
                      <i  uk-icon='icon: close;ratio:2' />
                    </a>
                  </div>
                </div>
                &nbsp;&nbsp;&nbsp;&nbsp;
                <span className="uk-text-bold">Enable Store Mode</span>
              </div>
              <div className="uk-width-auto">
                <SwitchButton
                  handleChange={handleChange}
                  name="store-mode"
                  defaultChecked={active}
                />
              </div>
            </div>
          </div>
          {true && (
            <div className="">
              
              <AdminCodeForm close={close} handleSubmit={handleSubmit} httpClient={httpClient} user={user} />
              
            </div>
          )}
        </section>
      </div>
    </ModalFloat>
  );
};

export default withAuthentication(AdminToken);
